var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSvg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7481 1.02248L3.58811 7.93248L1.68812 5.90248C1.33811 5.57248 0.788115 5.55248 0.388115 5.83248C-0.00188515 6.12248 -0.111885 6.63248 0.128115 7.04248L2.37811 10.7025C2.59811 11.0425 2.97811 11.2525 3.40811 11.2525C3.81811 11.2525 4.20812 11.0425 4.42811 10.7025C4.78812 10.2325 11.6581 2.04248 11.6581 2.04248C12.5581 1.12248 11.4681 0.312484 10.7481 1.01248V1.02248Z",
    fill: "#0C66E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSvg3);
export default __webpack_public_path__ + "static/media/CheckSvg3.aa70e96a6e9195bb41e4b0fa0cb45d3c.svg";
export { ForwardRef as ReactComponent };